/* @flow */
import Button from 'components/Button.jsx';
import cx from 'classnames';
import React, { Component, PropTypes } from 'react';

import './styles/PageControls.scss';

class PageControls extends Component {
  static propTypes = {
    onBack: PropTypes.func,
    onNext: PropTypes.func,
    nextText: PropTypes.string,
    disabledNext: PropTypes.bool,
    onPreview: PropTypes.func,
  }

  render() {
    return (
      <div className={cx('PageControls', this.props.className)}>
        {this.props.onBack &&
          <Button
            data-test="page-controls-back"
            size="small"
            level="secondary"
            onClick={this.props.onBack}>
            Back
          </Button>
        }

        {this.props.onPreview &&
          <Button
            size="small"
            level="secondary"
            className="PageControls-preview"
            onClick={this.props.onPreview}
            eventElementName="PageControls-preview">
            Preview
          </Button>
        }

        {this.props.onNext &&
          <Button
            data-test="page-controls-next"
            size="small"
            disabled={!!this.props.disabledNext}
            onClick={this.props.onNext}>
            {this.props.nextText || 'Next'}
          </Button>
        }
      </div>
    );
  }
}

export default PageControls;



// WEBPACK FOOTER //
// ./src/payments/components/PageControls.jsx